// extracted by mini-css-extract-plugin
module.exports = {"genericFilter":"tagFilter_genericFilter__z75pb","item":"tagFilter_item__XYuXW","selected":"tagFilter_selected__BxAOe","relativeFilter":"tagFilter_relativeFilter__YWcZt"};